import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-graduation-requirements',
  imports: [PillarPagesTemp],
  templateUrl: './graduation-requirements.html',
  styleUrl: './graduation-requirements.scss',
})
export class GraduationRequirements {

}
